import { IComponentOptions } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { IEmployee } from "@gtmhub/employees";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { ProfileType } from "@gtmhub/profile";
import { PlanningSessionsActions } from "@gtmhub/sessions/redux/session-actions";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { PlanningSessionService } from "@gtmhub/sessions/services/planning-session.service";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { INgRedux } from "@gtmhub/state-management";
import { ITeam } from "@gtmhub/teams";
import { ISessionsIdMap, Session } from "@webapp/sessions/models/sessions.model";

interface ProgressAndProcessSectionBindings {
  targetType: ProfileType;
  target: IEmployee | ITeam;
}

interface ProgressAndProcessSectionRedux {
  sessionIdMap: ISessionsIdMap;
  sessionsFetched: boolean;
  sessionsError: IUIError;
}

const bindStateToThis = (state: ISessionsStoreState): ProgressAndProcessSectionRedux => {
  const { map: sessionIdMap, isFetched: sessionsFetched, error: sessionsError } = state.sessions;
  return {
    sessionIdMap,
    sessionsFetched,
    sessionsError,
  };
};
export interface ProgressAndProcessSectionCtrl extends ProgressAndProcessSectionRedux, ProgressAndProcessSectionBindings {}

export class ProgressAndProcessSectionCtrl extends GtmhubController {
  indicators: { loading: boolean };
  relevantSessions: Session[];

  static $inject = ["PlanningSessionService", "UIErrorHandlingService", "$scope", "PlanningSessionsActions", "$ngRedux"];

  constructor(
    private planningSessionService: PlanningSessionService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $scope: IExtendedRootScopeService,
    private planningSessionsActions: PlanningSessionsActions,
    private $ngRedux: INgRedux
  ) {
    super();
  }

  $onInit(): void {
    this.onDestroy(this.$ngRedux.connect(bindStateToThis)(this));
    this.$ngRedux.dispatch(this.planningSessionsActions.getSessionsIfMissing());

    this.indicators = { loading: true };
    this.$scope
      .watchUntilAndRejectOnError(
        () => this.sessionsFetched && !!this.target && !!this.targetType,
        () => this.sessionsError
      )
      .then(
        () => {
          this.planningSessionService.getRelevantSessions({ id: this.target.id, type: this.targetType }, { fields: "id" }).then(
            (relevantSessions) => {
              this.relevantSessions = [];
              if (relevantSessions.length === 0) {
                this.indicators.loading = false;
              } else {
                relevantSessions.forEach((s) => {
                  this.relevantSessions.push(this.sessionIdMap[s.id]);
                });
              }
            },
            (rejection) => {
              this.indicators.loading = false;
              this.uiErrorHandlingService.handleModal(rejection);
            }
          );
        },
        () => {
          this.indicators.loading = false;
          this.uiErrorHandlingService.handleModal(this.sessionsError);
        }
      );
  }
}

export const ProgressAndProcessSectionComponent: IComponentOptions = {
  bindings: {
    target: "<",
    targetType: "@",
  },
  controller: ProgressAndProcessSectionCtrl,
  template: require("./progress-and-process-section.html"),
};
